/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable-next-line array-callback-return */
import ServicesForm from "./Form";
import { useParams } from 'react-router-dom';
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { CreateResourceAction, LoadResourceAction } from "../../../../Redux/Actions/CrudActions";

const ServicesCreate = () => {

    const { utility_id } = useParams(); 

    const ACTION_TYPE = "COMMON";

    const BACKEND_ROUTE = 'utility_services';

    const SUBMIT_BUTTON_NAME = 'Create a Service';

    const LIST_BACKEND_ROUTE = `services_by_utility/${utility_id}`;

    var fields = {name: '', description: '', status: '', utility_id:utility_id, utility_department_id:"", level_id: ''}

    const [errors, setErrors] = useState(fields);

    const [formData, setFormData] = useState(fields);

    const [refreshTable, setRefreshTable] = useState(false);

    const dispatch = useDispatch();

    const state = useSelector(state => state.common);

    useEffect(() => {
        dispatch({ type: `RESTART_${ACTION_TYPE}_FORM` });
    }, []);

    useEffect(() => {
        if (refreshTable) {
            dispatch(LoadResourceAction(LIST_BACKEND_ROUTE, ACTION_TYPE));
            setRefreshTable(false);
        };
    }, [refreshTable]);

    useEffect(() => {
        if (state.form.errors && state.form.errors.validation_errors) {
            const errors = state.form.errors.validation_errors;
            for (let error in errors) {
                var key = error;
                var value = errors[key][0];
                setErrors({ ...errors, [key]: value });
            }
            dispatch({ type: `RESTART_${ACTION_TYPE}_FORM` });
        }

        if (state.form.success) {
            setFormData(fields);
            setErrors(fields);
            dispatch({ type: `RESTART_${ACTION_TYPE}_FORM` });
            setRefreshTable(true);
        }

    }, [state]);

    function handleSubmit(e) {
        e.preventDefault();
        var FORM_DATA = {
            name: formData.name, 
            utility_id:utility_id, 
            status: formData.status, 
            level_id: formData.level_id,
            description: formData.description, 
            utility_department_id:formData.utility_department_id, 
        }
        dispatch(CreateResourceAction(BACKEND_ROUTE, FORM_DATA, ACTION_TYPE));
    }

    return (
        <ServicesForm
            data={formData}
            errors={errors}
            setData={setFormData}
            handleSubmit={handleSubmit}
            btnloading={state.form.loading}
            SubmitButtonName={SUBMIT_BUTTON_NAME}
        />
    );
}

export default ServicesCreate;
